module.exports = __webpack_public_path__ + "img/logo.992a2b12.png";